import { timelineStory } from "@/mocks/gossipData";

export default function TimelineSection() {
  const story = timelineStory;
  return (
    <section id="timeline" className="w-full py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          {/* 左侧封面与说明 */}
          <div className="lg:col-span-5 flex flex-col">
            <span className="inline-flex items-center gap-1.5 text-accent-600 text-xs font-semibold tracking-widest">
              <i className="ri-history-line"></i> COMPLETE STORY
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-extrabold text-foreground-950 leading-snug">
              {story.title}
            </h2>
            <div className="mt-5 relative rounded-lg overflow-hidden aspect-[16/10]">
              <img
                src={story.image}
                alt={story.alt}
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
              <div className="absolute top-3 left-3 bg-foreground-950/80 text-accent-200 text-xs font-medium rounded px-2.5 py-1 inline-flex items-center gap-1">
                <i className="ri-focus-3-line"></i> {story.kicker}
              </div>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              从荧幕初遇到正式官宣，再到互动减少、走向终局——我们把这段三年绯闻拆成一段清晰的时间轴，把网友关注的每个关键节点一次讲透。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-2">
              <a href="#about" className="whitespace-nowrap inline-flex items-center gap-1.5 rounded-md bg-primary-600 text-background-50 text-sm font-medium px-5 h-10 hover:bg-primary-700 transition-colors">
                <i className="ri-message-3-line"></i> 看看编辑怎么说
              </a>
            </div>
          </div>

          {/* 右侧时间线 */}
          <ol className="lg:col-span-7 relative flex flex-col">
            <div className="absolute left-[18px] top-2 bottom-2 w-px bg-background-300"></div>
            {story.points.map((point, idx) => (
              <li key={point.date} className="relative flex gap-5 pl-0 pb-7 last:pb-0">
                <span
                  className={`relative z-10 shrink-0 w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold ${
                    idx === story.points.length - 1
                      ? "bg-primary-600 text-background-50"
                      : "bg-background-50 border-2 border-accent-400 text-accent-600"
                  }`}
                >
                  {String(idx + 1).padStart(2, "0")}
                </span>
                <div className="flex-1 bg-background-50 border border-background-200 rounded-lg p-4 md:p-5">
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-1 mb-1.5">
                    <span className="text-xs font-semibold tracking-wider text-accent-700">{point.date}</span>
                    <span className="inline-flex items-center gap-1 text-[11px] text-foreground-500">
                      <i className="ri-focus-3-line"></i> 节点 {idx + 1}
                    </span>
                  </div>
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">{point.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{point.detail}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}